// sub-components
import Accordian from "../../components/Accordian";
import Modal from "../../components/Modal";
import TabLayout from "../../components/TabLayout";

import SpendingAverages from "./SpendingAverages";
import Ledger from "./Ledger";
import Accounts from "./Accounts";

const LavellaDashboard = ({ username }) => {
	return (
		<div className="lavella page dashboard dark-mode-disabled">
			<section>
				<div className="cont--lg">
					<p className="eyebrow">{username}'s Lavella Life</p>
					<h1 className="title3">Dashboard</h1>
				</div>
				<div className="cont--lg">
					<TabLayout
						container="tab-section lavella-life"
						theActiveTab={1}
						tabs={[
							{
								title: "Summary",
								content: <h4>Summary</h4>,
							},
							{
								title: "Spending Averages",
								content: <SpendingAverages />,
							},
							{
								title: "Accounts",
								content: <Accounts />,
							},
							{
								title: "Ledger",
								content: <Ledger />,
							},
							{
								title: "Forecasting",
								content: <h4>Forecasting</h4>,
							},
						]}></TabLayout>
				</div>
			</section>
		</div>
	);
};

export default LavellaDashboard;
